import React from 'react';
import { Box, CircularProgress, Fade } from '@mui/material';
import { alpha } from '@mui/material/styles';

export type ToolsPanelLoadingOverlayProps = {
  open: boolean;
};

/** שכבת טעינה מעל תוכן פאנל הכלים — רק ויזואלית, ללא שינוי לוגיקה */
const ToolsPanelLoadingOverlay: React.FC<ToolsPanelLoadingOverlayProps> = ({ open }) => {
  return (
    <Fade in={open} timeout={220} unmountOnExit>
      <Box
        sx={{
          position: 'absolute',
          inset: 0,
          zIndex: 2,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          bgcolor: (theme) => alpha(theme.palette.background.paper, 0.88),
          pointerEvents: 'auto',
        }}
      >
        <CircularProgress size={36} color="secondary" aria-label="Loading" />
      </Box>
    </Fade>
  );
};

export default React.memo(ToolsPanelLoadingOverlay);
